<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('data.export_title')"></page-header-title>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex xs12 class="pa-3">
          <v-select
            name="report"
            v-model="selectedModule"
            item-text="text"
            item-value="key"
            :items="modules"
            :label="$t('data.select_module')"
            clearable
            hide-details
          ></v-select>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-card class="mt-3" v-if="selectedModule">
      <v-card-text>
        <v-flex xs12 class="pa-3">
          <component :is="selectedModule"></component>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Export",

  components: {
    students: () => import("../partials/export/ExportStudents.vue"),
    studentgroups: () => import("../partials/export/ExportStudentGroups.vue"),
    educationprograms: () => import("../partials/export/ExportEducationProgram.vue"),
  },

  data() {
    return {
      modules: [
        { key: "students", text: this.$t("participants.title") },
        { key: "studentgroups", text: this.$t("studentgroups.title") },
        { key: "educationprograms", text: this.$t("educationprograms.title") },
      ],
      selectedModule: null
    }
  },

  created() {},

  methods: {}
}
</script>